import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  HOME_CHECK_STATUS_STRIPE_ACCOUNT_LINK_BEGIN,
  HOME_CHECK_STATUS_STRIPE_ACCOUNT_LINK_SUCCESS,
  HOME_CHECK_STATUS_STRIPE_ACCOUNT_LINK_FAILURE,
  HOME_CHECK_STATUS_STRIPE_ACCOUNT_LINK_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';
import config from '../../../common/config';

export function checkStatusStripeAccountLink(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: HOME_CHECK_STATUS_STRIPE_ACCOUNT_LINK_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${config.apiRootUrl}/subscriptions/check-status-stripe-account-link`,
        args,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_CHECK_STATUS_STRIPE_ACCOUNT_LINK_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_CHECK_STATUS_STRIPE_ACCOUNT_LINK_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCheckStatusStripeAccountLinkError() {
  return {
    type: HOME_CHECK_STATUS_STRIPE_ACCOUNT_LINK_DISMISS_ERROR,
  };
}

export function useCheckStatusStripeAccountLink() {
  const dispatch = useDispatch();

  const {
    checkStatusStripeAccountLinkPending,
    checkStatusStripeAccountLinkError,
  } = useSelector(
    (state) => ({
      checkStatusStripeAccountLinkPending:
        state.home.checkStatusStripeAccountLinkPending,
      checkStatusStripeAccountLinkError:
        state.home.checkStatusStripeAccountLinkError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(checkStatusStripeAccountLink(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissCheckStatusStripeAccountLinkError());
  }, [dispatch]);

  return {
    checkStatusStripeAccountLink: boundAction,
    checkStatusStripeAccountLinkPending,
    checkStatusStripeAccountLinkError,
    dismissCheckStatusStripeAccountLinkError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_CHECK_STATUS_STRIPE_ACCOUNT_LINK_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        checkStatusStripeAccountLinkPending: true,
        checkStatusStripeAccountLinkError: null,
      };

    case HOME_CHECK_STATUS_STRIPE_ACCOUNT_LINK_SUCCESS:
      // The request is success
      return {
        ...state,
        checkStatusStripeAccountLinkPending: false,
        checkStatusStripeAccountLinkError: null,
      };

    case HOME_CHECK_STATUS_STRIPE_ACCOUNT_LINK_FAILURE:
      // The request is failed
      return {
        ...state,
        checkStatusStripeAccountLinkPending: false,
        checkStatusStripeAccountLinkError: action.data.error,
      };

    case HOME_CHECK_STATUS_STRIPE_ACCOUNT_LINK_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        checkStatusStripeAccountLinkError: null,
      };

    default:
      return state;
  }
}
